export default __webpack_public_path__ + "static/media/seven.feb4d3ba.svg";